export default function customRender(text) {
  return text == '' || !text ? '--' : text;
}
